import { ModuleButton } from './../../../models/module-structure';
import { LayoutService } from './../../../layout/layout.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ViewerComponent } from './../viewer/viewer.component';
import { ParametersComponent } from './../parameters/parameters.component';
import { LayoutDefinitionType, ReportDetails } from './../report-details';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ReportService } from '../report.service';
import { NzCollapsePanelComponent } from 'ng-zorro-antd/collapse';
import { Guid } from 'src/app/models/guid';
import * as g from 'src/app/globals';
import * as moment from 'moment';
import { ReportParameterDataType } from '../report-parameter';

@Component({
  selector: 'app-report-main',
  templateUrl: './report-main.component.html',
  styleUrls: ['./report-main.component.less'],
})
export class ReportMainComponent implements OnInit {
  @ViewChild('resultPanel') resultPanel: NzCollapsePanelComponent;
  @ViewChild('parametersPanel') parametersPanel: NzCollapsePanelComponent;
  @ViewChild('reportParameters') reportParameters: ParametersComponent;
  @ViewChild('reportViewer') reportViewer: ViewerComponent;
  reportIdVal: number;
  thereAreParameters: boolean;
  loading = true;
  @Input() set reportId(val: number) {
    if (this.reportIdVal !== val) {
      this.reportIdVal = val;
      this.reportDetails = null;
      this.resultPanelActive = false;
      this.reportLoaded = false;
      this.init();
    }
  }
  get reportId(): number {
    return this.reportIdVal;
  }

  reportLoaded = false;
  reportDetails: ReportDetails;
  reportButton: ModuleButton[];
  resultPanelActive = false;
  parametersPanelActive = true;

  layoutDefinitionType = LayoutDefinitionType;
  reportSrc = '';

  constructor(
    private reportService: ReportService,
    private messageService: NzMessageService,
    private layoutService: LayoutService
  ) {}

  ngOnInit(): void {}

  init() {
    this.reportService
      .getReportDetails(this.reportId)
      .subscribe(
        (d: { layoutDefinition: ReportDetails; buttons: ModuleButton[] }) => {
          this.reportDetails = d.layoutDefinition;
          this.reportButton = d.buttons;

          if (this.thereAreParameters === false) {
            this.loadTheReport();
          }
        }
      );
  }

  loadingParametersCompleted(autoLoad: boolean) {
    this.loading = false;

    if (this.reportParameters.parameters.length === 0) {
      this.thereAreParameters = false;
      if (this.reportId != null) {
        this.init();
      }
    } else {
      this.thereAreParameters = true;
      if (autoLoad) {
        this.thereAreParameters = false;
        if (this.reportId != null) {
          this.init();
        }
      }
    }
  }

  reset() {
    this.reportParameters.parametersValues = {};
  }

  loadTheReport() {
    let reqParams = false;
    let parametersQueryString = '';
    this.reportParameters.parameters.forEach((p) => {
      let value = this.reportParameters.parametersValues[p.FieldName];
      if (value != null && p.DataType === ReportParameterDataType.Date) {
        value = moment(value).format(g.companyConfiguration.MomentDateFormat);
      }

      if (value != null && p.DataType === ReportParameterDataType.MultiSelect) {
        value = value.join(g.multiOptionsSeparator);
        console.log(value);
      }

      parametersQueryString += `&parameter_${
        ReportParameterDataType[p.DataType]
      }_${p.FieldName}=${encodeURIComponent(value)}`;

      if (!p.Required) {
        return;
      } else {
        if (
          this.reportParameters.parametersValues[p.FieldName] === undefined ||
          this.reportParameters.parametersValues[p.FieldName] === null ||
          this.reportParameters.parametersValues[p.FieldName] === ''
        ) {
          reqParams = true;
          this.messageService.error(
            this.layoutService.translate(
              'Parameter ' + p.Label + ' is required.'
            )
          );
        }
      }
    });

    if (reqParams) {
      return;
    }
    this.reportLoaded = true;
    this.resultPanelActive = true;
    this.parametersPanelActive = false;

    setTimeout(() => {
      if (this.reportDetails.Type === LayoutDefinitionType.CrystalReport) {
        this.reportSrc =
          g.apiBaseUrl +
          '/Report/PrintObject?id=' +
          this.reportDetails.Id +
          '&exportMode=5&mode=Preview&parameter_DropDown_fileCode=' +
          parametersQueryString +
          '&' +
          g.getUrlSuffix();
      } else {
        this.reportViewer.guid = Guid.newGuid();
        this.reportViewer.loadData(false);
      }
    }, 100);
  }
}
